import { HttpParams } from '@angular/common/http';

/* eslint-disable @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
export function withObjectParams(obj: any): HttpParams {
  let httpParams = new HttpParams();
  Object.keys(obj).forEach(key => {
    const value = obj[key];
    if (value !== null && value !== undefined) {
      httpParams = httpParams.set(key, value.toString());
    }
  });
  return httpParams;
}